var render = function render() {
  var _vm = this,
      _c = _vm._self._c;

  return _c('div', [!_vm.printRead ? _c('div', {
    staticClass: "res-switch"
  }, [_c('el-switch', _vm._g(_vm._b({
    attrs: {
      "disabled": !_vm.edit || _vm.disabled,
      "active-text": _vm.activeText,
      "inactive-text": _vm.inactiveText,
      "active-value": _vm.activeValue,
      "inactive-value": _vm.inactiveValue
    },
    model: {
      value: _vm.dataModel,
      callback: function ($$v) {
        _vm.dataModel = $$v;
      },
      expression: "dataModel"
    }
  }, 'el-switch', _vm.$attrs, false), _vm.$listeners))], 1) : _c('div', {
    staticClass: "res-switch"
  }, [_c('div', {
    staticClass: "res-print-read m-l-5"
  }, [_vm._v(_vm._s(_vm.valueToLabel))])]), _vm.description ? _c('div', {
    staticClass: "cmp-desc"
  }, [_vm._v(" " + _vm._s(_vm.description) + " ")]) : _vm._e()]);
};

var staticRenderFns = [];
export { render, staticRenderFns };